import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SqlServerCopySource } from 'app/model/pipeline/copysource/sql-server.copysource';
import { SqlCopySourceAdapter, sqlSourceAdapts } from './sql.copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlServerCopySource),
    asynchronous: true,
    adapts: sqlSourceAdapts
})
export class SqlServerCopySourceAdapter extends SqlCopySourceAdapter {}
